import { UserSelectors } from '@recruitee/account-data';
import { GdprConfiguration, GdprSaveBody } from '@recruitee/http/types';
import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';

const { actions, selectors, namespace, reducer } = createSingleEntityStore<GdprConfiguration>()(
  'GdprConfiguration',
  {
    references: makeRef => [makeRef('adminIds', 'admins', UserSelectors.byIds)],
    customActions: adapter => ({
      update: (state, payload: GdprSaveBody) => adapter.markAsPending(state),
      toggleGDPRFeature: (state, payload: GdprSaveBody) => adapter.markAsPending(state),
      toggleGDPRFeatureSuccess: (state, payload: GdprConfiguration) =>
        pipeState(adapter.update(state, payload), next => adapter.markAsLoaded(next)),
    }),
  },
);

export {
  actions as GdprConfigurationActions,
  selectors as GdprConfigurationSelectors,
  namespace as GdprConfigurationNamespace,
  reducer as GdprConfigurationReducer,
};
